/**
 * Jurisdiction coverage — Zod mirror of the service `JurisdictionCoverage`
 * (apps/api/src/services/lease-generation/clause-library.types.ts).
 *
 * Describes what the rules library does and does not know about the jurisdiction a unit sits in,
 * so every landlord surface can render a coverage notice from the same shape.
 */
import { z } from 'zod';
export const LocalOrdinanceCategorySchema = z.enum([
    'security_deposit',
    'late_fees',
    'termination_notice',
    'required_disclosures',
]);
export const JurisdictionCoverageSchema = z.object({
    matchBasis: z
        .enum(['MUNICIPALITY', 'UNINCORPORATED', 'MAILING_CITY'])
        .describe('How the locality was determined'),
    lookupPending: z
        .boolean()
        .describe('True when the basis is MAILING_CITY because the Census lookup is still pending'),
    state: z.object({
        code: z.string().describe('Two-letter state code'),
        name: z.string().describe('State name'),
        status: z.enum(['COVERED', 'UNCOVERED']).describe('Whether the library covers the state'),
    }),
    locality: z.object({
        name: z.string().nullable().describe('Locality name, when known'),
        type: z.enum(['city', 'county']).nullable().describe('Locality kind, when known'),
        county: z.string().nullable().describe('Containing county, when known'),
        tier: z
            .enum(['MODELED', 'KNOWN_UNMODELED', 'RESEARCHED_NONE', 'NOT_RESEARCHED'])
            .describe('How well the library covers the locality'),
        categories: z
            .array(LocalOrdinanceCategorySchema)
            .describe('Rule categories with a local ordinance the library does not model'),
    }),
});
//# sourceMappingURL=jurisdiction-coverage.js.map